import Logger, { flatten, serializeLocation } from "@mnemonic/logging";
import type { TInterceptorFunction } from "@mnemonic/router";

export const logRoute =
  ({ routeDeprecated = false } = {}): TInterceptorFunction<unknown> =>
  () => {
    Logger.getInstance()?.logInfo("RouteChange", {
      ...flatten(serializeLocation(window.location), { prefix: "location" }),
      "route.deprecated": routeDeprecated,
    });
    return null;
  };
